/* global mobile */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import moment from 'moment-timezone';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.form = options.form;
    this.notifications_form = $('form', this.el);
    this.phone_number_el = $('input[name="phone_number"]', this.notifications_form);
    this.phone_number_el.data('current', this.phone_number_el.val());
    this.submit_btn = $('input[type=submit]', this.notifications_form);
  },

  render: function () {
    this.timerId = window.setInterval(this.waitForWidgets, 100);
  },

  waitForWidgets: function () {
    this.notify_type_dropdown = $('#notification-type-dropdown', this.notifications_form).data('dropdown-view');
    this.timezone_dropdown = $('#timezone-dropdown', this.notifications_form).data('dropdown-view');
    this.send_notification_checkbox_view = $('a[data-name="send_notification"]', this.notifications_form).data('checkbox_view');

    if (
      this.notify_type_dropdown &&
              this.timezone_dropdown &&
              this.send_notification_checkbox_view &&
              (!this.form || this.form.rendered)
    ) {
      window.clearInterval(this.timerId);
      this.renderWithWidgets();
    }
  },

  renderWithWidgets: function () {
    this.notify_type_dropdown.on('selected', this.handle_type_select);
    this.handle_type_select(this.notify_type_dropdown.get_selected_value());
    if ($('li.active', this.timezone_dropdown.$el).length === 0) {
      // No timezone has been set, detect which timezone to use and set it
      var guess = moment.tz.guess();
      $('li[data-value="' + guess + '"]', this.timezone_dropdown.$el).click();
    }
  },

  handle_type_select: function (val) {
    if (val === 'S') {
      this.notifications_form.removeClass('no-number');
      this.phone_number_el.val(this.phone_number_el.data('current'));
      if (mobile) {
        this.submit_btn.prop('value', 'Next');
      }
    } else if (val === 'P') {
      this.notifications_form.addClass('no-number');
      this.phone_number_el.data('current', this.phone_number_el.val());
      // Put the value from the profile here in case the form is saved
      this.phone_number_el.val(this.phone_number_el.data('original'));
      if (mobile) {
        this.submit_btn.prop('value', 'Done');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/notifications.js